import React from 'react';
import { graphql } from 'gatsby';
import Divider from '@solid-ui-components/Divider';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import GetStarted from '@solid-ui-blocks/Features/Block07';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import Hero from '@solid-ui-blocks/Hero/Block07';
import MainTask from '@solid-ui-blocks/MainTask';
import ClientInfoBlock from '@solid-ui-blocks/ClientInfoBlock';
import { Flex } from 'theme-ui';
import styles from './_styles';

const { customerHeader, customerInfo } = styles;

const GarpiCement = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  return (
    <BasePage
      keywords={'workplace safety, occupational safety and health, safety reports, safety checklist, employee management program, task management, project management software, project tracking software, project tracking tools, action tracking'.split(
        ', '
      )}
      description={
        'Discover how GARPI Cement used an inspection app to boost productivity. Improve maintenance efficiency and safety through checklists in manufacturing.'
      }
      title={'GARPI Cement Enhances Operations & Workflow'}
      pathname={pathname}
      {...props}
    >
      <LayoutWrapper divider={<Divider />}>
        <Flex sx={customerHeader}>
          <Hero content={content['hero']} />
          <MainTask content={content['main-task']} />
        </Flex>
        <Flex sx={customerInfo}>
          <ClientInfoBlock content={content['info-block-1']} />
          <ClientInfoBlock content={content['info-block-2']} iconSize='xxs' />
          <ClientInfoBlock content={content['info-block-3']} iconSize='xxs' />
          <ClientInfoBlock content={content['info-block-4']} iconSize='xs' />
        </Flex>
        <GetStarted content={content['get-started']} />
      </LayoutWrapper>
    </BasePage>
  );
};

export const query = graphql`
  query homepageTargpatrolEnBlockContent {
    allBlockContent(
      filter: { page: { in: ["targpatrol-en/garpi-cement", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`;
export default GarpiCement;
